/**
 * Utility to force cleanup all authentication data
 * Used to resolve issues with stale tokens and cookies
 */

export function forceAuthCleanup() {
  // Clear all cookies by setting them with expired date
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  
  // Clear any localStorage items that might exist
  localStorage.clear();
  
  // Clear sessionStorage
  sessionStorage.clear();
}

/**
 * Check if there are conflicting tokens and clean up if needed
 */
export function checkAndCleanConflictingTokens() {
  // Check for multiple token cookies
  const cookies = document.cookie.split(';');
  const accessTokenCookies = cookies.filter(c => c.includes('access_token'));
  const refreshTokenCookies = cookies.filter(c => c.includes('refresh_token'));
  
  // If we have multiple access or refresh tokens, clean everything
  if (accessTokenCookies.length > 1 || refreshTokenCookies.length > 1) {
    forceAuthCleanup();
    return true;
  }
  
  // Also check for any session storage items that might cause conflicts
  const sessionKeys = Object.keys(sessionStorage);
  if (sessionKeys.some(key => key.includes('token') || key.includes('auth'))) {
    sessionStorage.clear();
  }
  
  return false;
}